import { FC } from 'react'

import { Flex, Square } from '@chakra-ui/react'
import { EDITOR_TOOL_BUTTON_SIZE } from '@editor/config/constants'
import useLongPress from '@editor/hooks/LongPress'
import { Tooltip } from '@infraloop/common'

interface CameraViewButtonProps {
  label: string
  icon: React.ReactElement
  hasSubtoolbar?: boolean
  disabled?: boolean
  onClick: () => void
  onLongPress?: () => void
}

const CameraViewButton: FC<CameraViewButtonProps> = ({
  label,
  icon,
  hasSubtoolbar,
  disabled,
  onClick,
  onLongPress,
}) => {
  const mouseLongPress = useLongPress(
    { onLongPress: onLongPress || (() => null), onClick },
    { delay: 300, shouldPreventDefault: true },
  )

  return (
    <Tooltip
      showArrow
      positioning={{ placement: 'top' }}
      label={
        label
      } /* TODO: style migration needed - p=2 */ /* TODO: style migration needed - fontSize=xs */ /* TODO: style migration needed - fontWeight=normal */
    >
      <Flex>
        <Square
          position="relative"
          color="white"
          fontSize="xl"
          size={EDITOR_TOOL_BUTTON_SIZE}
          {...(disabled ? {} : mouseLongPress)}
          opacity={disabled ? 0.3 : 1}
        >
          {icon}
        </Square>
        {hasSubtoolbar && (
          <Square
            position="absolute"
            top={0}
            right={0}
            size={2}
            borderBottomColor="transparent"
            borderRightColor="secondary.400"
            borderTopColor="secondary.400"
            borderLeftColor="transparent"
            borderWidth={4}
          />
        )}
      </Flex>
    </Tooltip>
  )
}

export default CameraViewButton
